// Вспомогательные методы для работы с числами и строками.
// TODO: разнести по отдельным модулям.

function bytesToMb(bytes) {
    return bytes / 1024 / 1024;
}

function round(number, digits) {
    return (+number).toFixed(digits);
}

function pluralize(n, titles) {
    // eslint-disable-next-line max-len
    // http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html?id=l10n/pluralforms
    const idx =
        // eslint-disable-next-line eqeqeq, no-nested-ternary
        n % 10 == 1 && n % 100 != 11
            ? 0
            : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2;
    return titles[idx];
}

function formatMoney(amount) {
    return (+amount)
        .toLocaleString("ru-RU", {
            style: "currency",
            currency: "RUB",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            useGrouping: `${Math.abs((+amount).toFixed())}`.length > 4,
        });
}

function join(arr, separator) {
    return arr
        .filter(Boolean)
        .join(separator !== undefined ? separator : ", ");
}

function formatDate(msec) {
    // convert timestamp to date string
    if (!msec) return "";

    const date = new Date(msec);
    return date.toJSON()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join(".");
}

function stripTags(val) {
    const regex = /(<([^>]+)>)/gi;
    return val.replace(regex, "");
}

function capitalize(str) {
    const array = str.split(" ");
    return array
        .map(word => word.charAt(0)
            .toUpperCase() + word.slice(1)
            .toLowerCase())
        .join(" ");
}

// рассчитывает контрольное число для защиты от ботов на основе csrf-токена и текущего времени
function calcChallenge(secret, seconds) {
    if (!secret || !seconds) return 0;

    // Convert timestamp to minutes
    const minutes = Math.floor(seconds / 60);

    // Calculate the challenge number
    let challenge = 0;
    for (let i = 0; i < secret.length; i++) {
        challenge += secret.charCodeAt(i);
    }

    // Add a non-monotonic incrementing factor
    const incFactor = 100 + (minutes % 100);
    challenge += incFactor * minutes;

    return challenge;
}

function formatString(string) {
    if (!string || typeof string !== "string") return "";
    return string.replaceAll("\"\"", "\"");
}

export default {
    bytesToMb,
    formatDate,
    formatMoney,
    join,
    pluralize,
    round,
    stripTags,
    capitalize,
    calcChallenge,
    formatString,
};
